import { render, staticRenderFns } from "./CocList.vue?vue&type=template&id=cd8a74a2&scoped=true"
import script from "./CocList.vue?vue&type=script&lang=js"
export * from "./CocList.vue?vue&type=script&lang=js"
import style0 from "./CocList.vue?vue&type=style&index=0&id=cd8a74a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8a74a2",
  null
  
)

export default component.exports